<template>
    <div class="third typeConfig">
        <div class="third-formOne">
            <div class="formOne-btn">
                <div class="btn-left">
                    <span class="left-back-icon" @click="changeComponent">
                        <i class="el-icon-arrow-left"></i>
                        <span class="left-back-title">返回</span>
                    </span>
                    <span class="left-back-shu">
                        <span class="left-back-shu-content"></span>
                    </span>
                    <span class="left-back-content">{{ headerName }}</span>
                </div>
                <div class="btn-right">
                    <el-button v-el-disabel-repeat-click @click="submitForm('faqForm')" class="btn-two" type="primary">保存</el-button>
                    <el-button @click="Reset" class="btn-two" type="default">重置</el-button>
                </div>
            </div>
            <div class="third-one library">
                <div class="formOne-forms" style="margin-top: 57px;">
                    <div class="forms-one">
                        <div class="one-title">
                            <div class="title-left">
                                <span class="left-icon">
                                    <i class="el-icon-s-operation"></i>
                                </span>
                                <span class="left-content">基本信息</span>
                            </div>
                        </div>
                        <el-form :inline="false" :model="faqForm" ref="faqForm" :rules="faqFormRules" label-width="76px" @validate="validateTwo" :show-message="false">
                            <div class="one-list">
                                <div class="list-one-line">
                                    <el-form-item label="分类名称" prop="typeName">
                                        <el-input
                                            class="list-input"
                                            :maxlength="30"
                                            v-model.trim="faqForm.typeName"
                                            placeholder="请输入"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { removeStore, getStore } from "@/utils/store";
import { mapActions, mapState, mapMutations } from "vuex";
import { cloneDeep } from "lodash";
import { encrypt } from "@/utils/encrypt";
export default {
    name: "typeConfig",
    props: {
        enterType: Object
    },
    data() {
        return {
            headerName: '',
            hignModal: false, // 提示弹窗
            total: 0, //总共条数
            pageSize: 10, //每页条数
            currentPage: 1, //页码
            tableData: [], //列表数据
            hignSearchRes: '', // 高级检索条件
            orderConfig: '', // 顺序设置
            infoInit: '',
            faqForm: {
                typeName: '',
            },
            faqFormRules: {
                typeName: [
                    { required: true, message: "请输入分类名称", trigger: "change" }
                ],
            },
            tableRow: [
                {
                    column: "评分用户姓名",
                    key: "userName",
                    needKeyValue: false,
                    caseKey: "user_name"
                },
                {
                    column: "评分用户登录账号",
                    key: "userId",
                    needKeyValue: false,
                    caseKey: "user_id"
                },
                {
                    column: "评分用户身份",
                    key: "userType",
                    needKeyValue: false,
                    caseKey: "user_type"
                },
                {
                    column: "评分",
                    key: "score",
                    needKeyValue: false,
                    caseKey: "score"
                },
                {
                    column: "评分时间",
                    key: "createTime",
                    needKeyValue: false,
                    caseKey: "create_time"
                },
            ],
            countNum: 0,
            typeID: '',
        };
    },
    computed: {
        ...mapState({
            userInfo: state => state.user.userInfo,
            componentsName: state => state.robotsManage.robotsManage_faqLibrary_ComponentName,
        })
    },
    created() {
        if (this.enterType) {
            this.headerName = '编辑分类信息'
            this.faqForm.typeName = this.enterType.typeName
            this.typeID = this.enterType.questionType
        } else {
            this.headerName = '新建分类信息'
            this.typeID = ''
        }

    },
    methods: {
        ...mapActions([
            'saveOrUpdate',
        ]),
        ...mapMutations({
            changeComponentName: 'SET_robotsManage_faqLibrary_ComponentName',
        }),
        // 验证
        validateTwo(prop, msgStatus, validateMessage) {
            if (!msgStatus && !this.countNum) {
                this.countNum += 1;
                if (validateMessage) {
                    this.$message.error(validateMessage)
                }
            }
        },
        //表单验证
        submitForm(formName) {
            this.countNum = 0;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.saveOrUpdateFuc();
                } else {
                    return false;
                }
            });
        },
        Reset() {
            this.$refs["faqForm"].resetFields();
            this.faqForm.typeName = this.enterType.typeName
            this.typeID = this.enterType.questionType
        },
        // 新增或者修改机器人分类
        async saveOrUpdateFuc() {
            const {
                data: { msg, status }
            } = await this.saveOrUpdate({
                questionType: this.typeID,
                typeName: this.faqForm.typeName
            })
            if (status === 1000) {
                this.$message.success('操作成功')
                setTimeout(() => {
                    this.changeComponent()
                }, 2000);
                return
            }
            this.$message.error(msg);
        },
        // 改变index页面的component的值
        changeComponent() {
            removeStore({
                name: "TypeConfig",
                type: "session"
            })
            this.changeComponentName("BasicPage");
        },
    }
};
</script>

<style lang="scss">
.typeConfig {
    min-height: 100vh;
    .third-formOne {
        height: 100vh;
    }
    .el-table__body-wrapper {
        height: calc(100vh - 210px) !important;
    }
}
</style>
